import React, {FC} from "react";
import firebase from "firebase";
import {useAppDispatch} from "../../redux/redux.hook";
import {SerializedError} from "@reduxjs/toolkit";
import {setAppError} from "../../redux/app.slice";
import {UserRole} from "../redux/types";
import {AuthService} from "../redux/Auth.service";
import {useLogout} from "../redux/auth.hook";

interface AuthState {
    userId: string | null;
    role: UserRole | null;
    setAuth: (userId: string, Role: UserRole) => void;

}

export const AuthContext = React.createContext<AuthState>({
    role: null,
    userId: null,
    setAuth: () => {
    }
});

const authService = new AuthService();

export const AppAuthProvider: FC = ({children}) => {

    const {logout} = useLogout();
    const [userId, setUserId] = React.useState<string | null>(localStorage.getItem('userId'));
    const [userRole, setUserRole] = React.useState<UserRole | null>(localStorage.getItem('userRole') as UserRole | null);

    const setAuth = (userId: string, role: UserRole) => {
        setUserRole(role);
        setUserId(userId);
    }

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                authService.getUserAuthorization(user.uid)
                    .then(authorization => {
                        setUserId(user.uid);
                        setUserRole(authorization.role);
                        localStorage.setItem('userId', user.uid)
                        localStorage.setItem('userRole', authorization.role)
                    })
                    .catch(() => {
                        logout();
                    })
            } else {
                setUserId(null);
                setUserRole(null);
                logout();
            }
        }, (error) => {
            const serializableError: SerializedError = {
                message: error.message,
                code: error.code
            }
            dispatch(setAppError(serializableError))
        });
    }, [dispatch, logout]);

    return (
        <AuthContext.Provider value={{userId, role: userRole, setAuth}}>
            {children}
        </AuthContext.Provider>
    );
};